import { render, staticRenderFns } from "./MenuTecnici.vue?vue&type=template&id=bc6167b4&"
import script from "./MenuTecnici.vue?vue&type=script&lang=js&"
export * from "./MenuTecnici.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports